module.exports = __webpack_public_path__ + "img/forgot_password.6a303d93.svg";